/**
 * @file index.jsx
 * @author Daniel Aguirre
 * @description manage header service state
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  CheckCircleFilled,
  CloseCircleFilled,
  LoadingOutlined,
  WarningFilled
} from '@ant-design/icons';

function HeaderServiceState({ componentsData }) {
  const { t: translate } = useTranslation();

  const headersDefinition = {
    success: {
      message: 'components.titleSuccess',
      textColor: 'text-correctGreen',
      state: 'success'
    },
    warning: {
      message: 'components.titleWarning',
      textColor: 'text-brandOrange',
      state: 'warning'
    },
    error: {
      message: 'components.titleError',
      textColor: 'text-error',
      state: 'error'
    },
    loading: {
      message: 'components.loading',
      textColor: '',
      state: 'loading'
    }
  };

  const [header, setHeader] = useState(headersDefinition.loading);

  const getIcon = (stateName) => {
    const iconStyle = { fontSize: '26px' };
    if (stateName === 'success') return <CheckCircleFilled style={iconStyle} />;
    if (stateName === 'warning') return <WarningFilled style={iconStyle} />;
    if (stateName === 'error') return <CloseCircleFilled style={iconStyle} />;
    return <LoadingOutlined />;
  };

  useEffect(() => {
    const componentFilter = componentsData.filter(
      (component) => component.state === 'online'
    );

    if (componentFilter.length === componentsData.length) {
      setHeader(headersDefinition.success);
    } else if (componentFilter.length === 0) {
      setHeader(headersDefinition.error);
    } else {
      setHeader(headersDefinition.warning);
    }
  }, [componentsData]);

  const { message, textColor, state } = header;
  return (
    <div className="p-3">
      <h2
        style={{ fontSize: '16px' }}
        className={`text-sm ${textColor} flex items-center`}>
        {getIcon(state)}
        <span className="ml-2.5 font-bold">{translate(message)}</span>
      </h2>
    </div>
  );
}

HeaderServiceState.propTypes = {
  componentsData: PropTypes.array.isRequired
};

export default HeaderServiceState;
